import Vue from 'vue'
import AgGridColumnMethodMixins from '@/Mixins/SigmaClientNew/AgGridColumnMethods'

// import { getSimpleDate } from '@/utils/helpers/FormatDate'
/*
* AG Grid Column Defs here
*/
export default Vue.extend({
  mixins: [AgGridColumnMethodMixins],
  data () {
    return {
      rowSelect: {
        field: 'selection',
        maxWidth: 40,
        minWidth: 40,
        headerCheckboxSelection: true,
        checkboxSelection: true
      },
      ledgerColumn: {
        headerName: 'ID',
        field: 'ledger',
        colId: 'ledger',
        maxWidth: 60,
        minWidth: 60,
        editable: false,
        sortable: true,
        sort: 'desc',
        cellStyle: this.getStyles(),
        cellRenderer: (params) => params.data ? this.buildLink(params) : '',
        valueSetter: () => null
      },

      idColumn: {
        headerName: 'ID',
        field: 'id',
        colId: 'id',
        maxWidth: 60,
        minWidth: 60,
        editable: false,
        sortable: true,
        sort: 'desc',
        cellStyle: this.getStyles(),
        cellRenderer: (params) => params.data ? this.buildLink(params) : '',
        valueGetter: (params) => {
          return (params.data) ? `PO${params.data.id}` : ''
        },
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueSetter: () => null
      },
      // Simulated Column
      numberColumn: {
        headerName: 'Number',
        field: 'number',
        colId: 'number',
        maxWidth: 250,
        minWidth: 150,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles(),
        comparator: (valueA, valueB, nodeA, nodeB, isInverted) => {
          // Sorting based on 'index'
          const indexA = nodeA.data.index
          const indexB = nodeB.data.index

          if (indexA === indexB) {
            return 0
          } else {
            return indexA < indexB ? -1 : 1
          }
        },
        cellRenderer: (params) => params.data ? this.buildLink(params) : '',
        valueSetter: () => null
      },

      // Simulated Column
      vendorColumn: {
        headerName: 'Vendor',
        field: 'vendor',
        colId: 'vendor',
        maxWidth: 250,
        minWidth: 150,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('vendor'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => {
          if (params.data) {
            const vendor = params.data.vendor_data || params.data.vendor
            return vendor ? vendor.name : ''
          } else {
            return ''
          }
        },
        valueSetter: () => null
      },

      // Simulated Column
      descriptionColumn: {
        headerName: 'Description',
        field: 'description',
        colId: 'description',
        maxWidth: 400,
        minWidth: 300,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('description'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => params.data ? params.data.description : '',
        valueSetter: () => null
      },

      amountColumn: {
        headerName: 'Amount',
        field: 'amount_decimal',
        colId: 'amount_decimal',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        sortable: true,
        type: 'rightAligned',
        cellStyle: this.getStyles('amount'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => {
          return (params.data && params.data.amount_decimal) ? Number(params.data.amount_decimal).toFixed(2) : '0.00'
        },
        valueSetter: () => null
      },
      envelopeAmountColumn: {
        headerName: 'Envelope Amount',
        field: 'amount_decimal',
        colId: 'amount_decimal',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        sortable: true,
        type: 'rightAligned',
        cellStyle: this.getStyles('amount'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => {
          return (params.data && params.data.amount_decimal) ? Number(params.data.amount_decimal).toFixed(2) : '0.00'
        },
        valueSetter: () => null
      },

      debitsAmountColumn: {
        headerName: 'Amount',
        field: 'debits_decimal',
        colId: 'debits_decimal',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        sortable: true,
        type: 'rightAligned',
        cellStyle: this.getStyles('amount'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => (params.data && params.data.debits_decimal) ? Number(params.data.debits_decimal).toFixed(2) : '',
        valueSetter: () => null
      },

      debitsDecimalAmountColumn: {
        headerName: 'Amount',
        field: 'amount',
        colId: 'amount',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        sortable: true,
        type: 'rightAligned',
        cellStyle: this.getStyles('amount'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => params.data ? Number(params.data.amount_decimal || params.data.debits_decimal || 0).toFixed(2) : '',
        valueSetter: () => null
      },

      originalAmountColumn: {
        headerName: 'Original Amount',
        field: 'amount_decimal',
        colId: 'amount_decimal',
        type: 'rightAligned',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('amount'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => (params.data && params.data.amount_decimal) ? Number(params.data.amount_decimal).toFixed(2) : '',
        valueSetter: () => null
      },

      remainingAmountColumn: {
        headerName: 'Remaining',
        field: 'remaining',
        colId: 'remaining',
        maxWidth: 200,
        type: 'rightAligned',
        minWidth: 100,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('amount'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => (params.data && params.data.remaining) ? Number(params.data.remaining).toFixed(2) : '',
        valueSetter: () => null
      },

      dateColumn: {
        headerName: 'Date',
        field: 'date',
        colId: 'date',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('date'),
        comparator: (date1, date2) => {
          const dateObj1 = new Date(date1)
          const dateObj2 = new Date(date2)
          return dateObj1.getTime() - dateObj2.getTime()
        },
        valueGetter: (params) => params.data ? params.data.date : '',
        valueSetter: () => null
      },
      dueDateColumn: {
        headerName: 'Due Date',
        field: 'due_date',
        colId: 'due_date',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('date'),
        valueGetter: (params) => params.data ? params.data.date_due : '',
        comparator: (date1, date2) => {
          const dateObj1 = new Date(date1)
          const dateObj2 = new Date(date2)
          return dateObj1.getTime() - dateObj2.getTime()
        },
        valueSetter: () => null
      },
      batchColumn: {
        headerName: 'Batch',
        field: 'batch',
        colId: 'batch',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('batch'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => (params.data && params.data.batch_data) ? params.data.batch_data.name : '',
        valueSetter: () => null
      },

      currencyColumn: {
        headerName: 'Currency',
        field: 'currency',
        colId: 'currency',
        maxWidth: 80,
        minWidth: 80,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('currency'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => params.data && params.data.currency_data ? params.data.currency_data.code : '',
        valueSetter: () => null
      },

      paymentTypeColumn: {
        headerName: 'Payment Type',
        field: 'payment_type',
        colId: 'payment_type',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('payment_type'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => params.data ? params.data.payment_type : '',
        valueSetter: () => null
      },

      bankColumn: {
        headerName: 'Bank',
        field: 'bank',
        colId: 'bank',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('bank'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => {
          if (params.data) {
            const bank = params.data.bank_data || params.data.bank
            return bank ? bank.name : ''
          } else {
            return ''
          }
        },
        valueSetter: () => null
      },

      signatureApprovalsColumn: {
        headerName: 'Signature Approvals',
        field: 'signature_status',
        colId: 'signature_status',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('signature_status'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => params.data ? params.data.signature_status : '',
        valueSetter: () => null
      },

      isNotifiedColumn: {
        headerName: 'Email Status',
        field: 'is_notified',
        colId: 'is_notified',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        cellStyle: this.getStyles('signature_status'),
        comparator: (a, b) => {
          return a.localeCompare(b, undefined, { numeric: true })
        },
        valueGetter: (params) => params.data ? ((params.data.payment_type === 'EFT') ? (params.data.is_notified ? 'Sent' : 'Unsent') : 'N/A') : '',
        valueSetter: () => null
      },

      actionsColumn:
      {
        field: 'Status',
        cellRenderer: 'agGridBtnRender',
        cellStyle: this.getStyles('actions'),
        minWidth: 180
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/Mixins/SigmaClientNew/AgGridTransactionsColumns.js